import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Link from '../Link';
import { useStaticQuery, graphql } from "gatsby";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export default function SubNavDesktop(props) {
  const classes = useStyles();
  const data = useStaticQuery(graphql`
      query TopSubNavDesktopItems {
        allWpMenu(filter: {locations: {eq: HEADER_SUB_MENU}}) {
            nodes {
                id
                name
                slug
                menuItems {
                  nodes {
                      id
                      title
                      url
                      path
                      label
                      target
                      order
                      childItems {
                        nodes {
                            id
                            title
                            url
                            path
                            label
                            target
                            order
                        }
                      }
                    }
                  }
                }
              }
            }
      `);
  return (
      <React.Fragment>
          <Toolbar component="nav" disableGutters={true} className={`sub-nav  ${classes.SubNavDesktop}`}>
                {data.allWpMenu.nodes[0].menuItems.nodes.map((section) => (
                  <Link
                      key={section.path}
                      to={section.path}
                  >
                    {section.label}
                  </Link>
              ))}
          </Toolbar>
      </React.Fragment>
  );
}